module.exports = __webpack_public_path__ + "static/img/user-1.9e4fe277.svg";